import Section, { ESectionType } from '@/components/Section/Section'
import Header from '@/components/Header/Header'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@/store/store'
import Footer from '@/components/Footer/Footer'
import ModalFull from '@/components/ModalFull/ModalFull'
import Layout from '@/components/Layout/Layout'
import styles from '@/components/Pricing/Pricing.module.scss'

import METADATA from '@/data/metadata'
import globalSlice from '@/store/reducers/global'

const AiPage = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(globalSlice.actions.setHeaderAppear(true))
    return () => {
      dispatch(globalSlice.actions.setHeaderAppear(false))
    }
  }, [dispatch])

  return (
    <Layout {...METADATA}>
      <Header />
      <Section type={ESectionType.ai}></Section>
      <Section type={ESectionType.joinFooter} className={styles.footer_pricing}></Section>
      <ModalFull />
      <Footer />
    </Layout>
  )
}

export default AiPage
